export default __webpack_public_path__ + "static/media/0K9A9616.5353b597.JPG";